<script lang="ts">import { stateUi } from "@infinitro/config";
let { styleCustom = "", styleCustomWrapper = "", className = "", fullWidth = true, minWidth = false, maxWidth = true, width = "100%", noPaddingX = false, padding = undefined, isHomePageContainer = false, children } = $props();
</script>

<div
	class:full-container={!isHomePageContainer}
	class:full-container-home-page={isHomePageContainer}
	class="full-container"
	class:full-container--compact-vertical={$stateUi.layout?.useCompactVerticalPagePadding}
	style={styleCustomWrapper}
>
	<div
		class:full-width={fullWidth}
		class:min-width={minWidth}
		class:max-width={maxWidth}
		class:no-padding-x={noPaddingX}
		class:padding-4={padding === 'padding-4'}
		class:padding-8={padding === 'padding-8'}
		class:padding-12={padding === 'padding-12'}
		class:padding-16={padding === 'padding-16'}
		class="infinitro-container {className}"
		style="width: {width}; {styleCustom}"
	>
		{@render children?.()}
	</div>
</div>

<style>
	.full-container {

    display: flex;

    height: -moz-fit-content;

    height: fit-content;

    width: 100%;

    max-width: 100vw;

    justify-content: center;

    padding-top: 1.5rem;

    padding-bottom: 1.5rem;

    padding-left: 0px;

    padding-right: 0px
}

@media (min-width: 1024px) {

    .full-container {

        padding: 2rem
    }
}

	.full-container-home-page {

    display: flex;

    height: -moz-fit-content;

    height: fit-content;

    width: 100%;

    max-width: 100vw;

    justify-content: center;

    padding-top: 1rem;

    padding-bottom: 1rem;

    padding-left: 0px;

    padding-right: 0px
}

	@media (min-width: 1024px) {

    .full-container-home-page {

        padding-left: 2rem;

        padding-right: 2rem;

        padding-top: 1rem;

        padding-bottom: 1rem
    }
}

	.full-container--compact-vertical {

    display: flex;

    height: -moz-fit-content;

    height: fit-content;

    width: 100%;

    max-width: 100vw;

    justify-content: center;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    padding-left: 0px;

    padding-right: 0px
}

	@media (min-width: 1024px) {

    .full-container--compact-vertical {

        padding: 2rem
    }
}

	.infinitro-container {

    position: relative;

    display: flex;

    height: -moz-fit-content;

    height: fit-content;

    width: 100%;

    flex-direction: column;

    align-items: center;

    gap: 1rem
}

	.full-width {

    width: 100%
}

	.no-padding-x {

    padding-left: 0px;

    padding-right: 0px
}

	.max-width {

    max-width: 92vw
}

	@media (min-width: 1280px) {

    .max-width {

        max-width: 1400px
    }
}

	.min-width {

    min-width: -moz-fit-content;

    min-width: fit-content
}

	.padding-4 {

    padding-left: 1rem;

    padding-right: 1rem
}

	.padding-8 {

    padding-left: 2rem;

    padding-right: 2rem
}

	.padding-12 {

    padding-left: 3rem;

    padding-right: 3rem
}

	.padding-16 {

    padding-left: 4rem;

    padding-right: 4rem
}
</style>
